import { Action } from 'redux';
import { ElementFn } from '../../elements/elementAction';
import { Functions } from '../../types/types';
import { JobRole } from '../../enums/JobRole';
import { Role } from '../../enums/Role';

export interface AppUser {
  roles: Role[];
  jobRoles: JobRole[];
  employeeId: number;
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface AppState {
  user?: AppUser;
  elFn?: Partial<ElementFn<Functions>>;
  sessionExpiry?: { expired: boolean };
  authError?: string;
}

const UPDATE_APP_STATE = 'UPDATE_APP_STATE';
export const updateAppState = (newState: Partial<AppState>) => ({
  type: UPDATE_APP_STATE,
  ...newState
});

type AppAction = Action & Partial<AppState>;

const appReducer = (
  state: AppState = { elFn: {} },
  action: AppAction
): AppState => {
  const { type, ...newState } = action;
  switch (type) {
    case UPDATE_APP_STATE:
      return { ...state, ...newState };
    default:
      return state;
  }
};

export default appReducer;
